import React from 'react';

import './NavBar.css';

export const NavBarFooter: React.FC<{ footer: React.ReactNode }> = ({ footer }) => (
  <div className="navbar__footer">{footer}</div>
);
